import React from 'react';
import type { ReactNode } from 'react';
import moment from 'moment';
import type { ToolbarProps } from 'react-big-calendar';
import type { CalendarComponentEvent } from '@axiom/validation';

import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Button } from '../../element/Button/Button';
import { IconButton } from '../../element/Button/IconButton';

export type CalendarToolbarProps = ToolbarProps<CalendarComponentEvent> & {
  name?: string;
  // Optional node rendered just to the right of the Today button and
  // before the Previous/date/Next controls. Intended for per-instance
  // affordances (e.g. envoy's 5-min/15-min zoom toggle) so callers can
  // extend the toolbar without the shared component needing to know
  // about the specific feature.
  leftSlot?: ReactNode;
};

export const CalendarToolbar = ({
  name,
  date,
  label,
  onNavigate,
  leftSlot,
}: CalendarToolbarProps) => {
  return (
    <Gutter name={name} bottom="8px">
      <Layout position="middle" name="TOOLBAR">
        <LayoutItem>
          <Button
            name="TODAY_BUTTON"
            pattern="secondary"
            variation="outline"
            onClick={() => {
              onNavigate('TODAY');
            }}
          >
            Today
          </Button>
        </LayoutItem>
        {leftSlot ? (
          <LayoutItem name="LEFT_SLOT" leftGutter="8px" fluid>
            {leftSlot}
          </LayoutItem>
        ) : (
          <LayoutItem name="LEFT_SLOT_SPACER" fluid />
        )}
        <LayoutItem rightGutter="8px">
          <IconButton
            name="PREVIOUS"
            pattern="secondary"
            variation="minimal"
            icon="arrow-left"
            disabled={moment(date).isSameOrBefore(new Date())}
            onClick={() => {
              onNavigate('PREV');
            }}
          />
        </LayoutItem>
        <LayoutItem name="DATE_LABEL">{label}</LayoutItem>
        <LayoutItem leftGutter="8px">
          <IconButton
            name="NEXT"
            pattern="secondary"
            variation="minimal"
            icon="arrow-right"
            onClick={() => {
              onNavigate('NEXT');
            }}
          />
        </LayoutItem>
      </Layout>
    </Gutter>
  );
};
